// extracted by mini-css-extract-plugin
module.exports = {"description":"author-template-module--description--1Kkbh"};